import { Pipe, PipeTransform } from '@angular/core';

  @Pipe({ standalone: true, name: 'replace' })
  export class ReplaceStringPipe implements PipeTransform {
      transform(value: string, oldValue: string, newValue: string): string {
          return value.replace(oldValue, newValue);
      }
}

@Pipe({ standalone: true, name: 'localebykey' })
export class LocaleByKeyPipe implements PipeTransform {
    transform(items: Array<any>, key: string, view : string): string {
        const localeMatches = items.filter(item => {
            return item.key === key && (item.view === null || item.view === undefined || item.view === view);
        });

        if (localeMatches.length > 0) {
            return localeMatches[0].value;            
        } else {
            return "";
        }
    }
}